import React from "react";
import styled from "styled-components";
import { Alert, Row } from "components/bootstrap";
import { emptyComparisonExpressionConfig } from "logic/alerts/AggregationExpressionConfig";
import validateExpression from "logic/alerts/AggregationExpressionValidation";
import AggregationConditionExpression from "./AggregationConditionExpression";
import AggregationConditionsFormSummary from "./AggregationConditionsFormSummary";
import commonStyles from "../common/commonStyles.css";
const initialEmptyConditionConfig = emptyComparisonExpressionConfig();
const extractSeriesReferences = (expression, acc = []) => {
  if (expression.expr === "number-ref") {
    acc.push(expression.ref);
  }
  if (expression.left && expression.right) {
    return extractSeriesReferences(expression.left).concat(extractSeriesReferences(expression.right));
  }
  if (expression.child) {
    return extractSeriesReferences(expression.child);
  }
  return acc;
};
const StyledAlert = styled(Alert)`
  margin-bottom: 10px !important;
`;
class AggregationConditionsForm extends React.Component {
  constructor(props) {
    super(props);
    this.toggleShowInlineValidation = () => {
      const { showInlineValidation } = this.state;
      this.setState({ showInlineValidation: !showInlineValidation });
    };
    this.handleChange = (changes) => {
      var _a, _b;
      const { eventDefinition, onChange } = this.props;
      if (!Object.keys(changes).includes("conditions")) {
        onChange(changes);
        return;
      }
      const nextConditions = changes.conditions;
      let nextSeries;
      if (nextConditions) {
        const seriesReferences = extractSeriesReferences(nextConditions);
        nextSeries = ((_b = changes.series || ((_a = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _a.series)) == null ? void 0 : _b.filter((s) => seriesReferences.includes(s.id))) || [];
      } else {
        nextSeries = [];
      }
      onChange({
        ...changes,
        conditions: { expression: nextConditions },
        series: nextSeries
      });
    };
    this.state = {
      showInlineValidation: false
    };
  }
  render() {
    var _a, _b, _c, _d, _e, _f;
    const { showInlineValidation } = this.state;
    const { eventDefinition, validation } = this.props;
    const expression = ((_b = (_a = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _a.conditions) == null ? void 0 : _b.expression) || initialEmptyConditionConfig;
    const expressionValidation = validateExpression(expression, ((_c = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _c.series) || []);
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h3", { className: commonStyles.title }, "Create Events for Definition"), validation.errors.conditions && /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "danger", title: "Errors found" }, /* @__PURE__ */ React.createElement("p", null, (_d = validation == null ? void 0 : validation.errors) == null ? void 0 : _d.conditions[0])), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
      AggregationConditionExpression,
      {
        expression,
        ...this.props,
        validation: showInlineValidation ? expressionValidation.validationTree : {},
        onChange: this.handleChange
      }
    )), /* @__PURE__ */ React.createElement(
      AggregationConditionsFormSummary,
      {
        conditions: ((_e = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _e.conditions) || {},
        series: ((_f = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _f.series) || [],
        expressionValidation,
        showInlineValidation,
        toggleShowValidation: this.toggleShowInlineValidation
      }
    ));
  }
}
export default AggregationConditionsForm;
